import type { PostStatus } from '~publish/components/graphqlEnums'
import { channelSchedule, schedule } from '~publish/legacy/routes'

import { mapPostStatusToTab } from './mapPostStatusToTab'

export type PostPermalinkPost = {
  id: string
  status: PostStatus
  channelId: string
  /**
   * Not the same as having a `postGroup`: a group is a composer session, so a
   * single-channel post still gets one, with itself as the only member.
   */
  hasSiblingPosts: boolean
}

/**
 * Where a permalink resolves to: the post's own list view, on the tab that lists
 * it, with the details dialog on top. The two branches can't share a path shape
 * — all-channels nests the dialog under `posts/`, a channel schedule doesn't.
 */
export const buildPostPermalinkTarget = (post: PostPermalinkPost): string => {
  const search = `?tab=${mapPostStatusToTab(post.status)}`

  if (post.hasSiblingPosts) {
    return `${schedule.buildPathname()}/posts/${post.id}${search}`
  }

  return `${channelSchedule.buildPathname({ id: post.channelId })}/${
    post.id
  }${search}`
}
